var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        attrs: {
          "error-messages": _vm.validationMessage,
          items: _vm.items,
          label: _vm.contextLabel,
          "menu-props": { value: false },
          "append-icon": "cloud_upload",
          "item-text": "itemName",
          "item-value": "id"
        },
        nativeOn: {
          focusin: function($event) {
            _vm.dialog = true
          }
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(data) {
              return _c(
                "div",
                { staticStyle: { width: "calc(100% - 15px)", height: "32px" } },
                [
                  _c(
                    "v-chip",
                    {
                      key: JSON.stringify(data.item),
                      staticStyle: { "max-width": "100%", overflow: "hidden" },
                      attrs: { "input-value": data.selected, small: "" },
                      on: {
                        input: function($event) {
                          return data.parent.selectItem(data.item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(data.item.itemName) + " ")]
                  )
                ],
                1
              )
            }
          }
        ]),
        model: {
          value: _vm.contextModel,
          callback: function($$v) {
            _vm.contextModel = $$v
          },
          expression: "contextModel"
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("components.ajaxFile.headline")))
                ])
              ]),
              _vm._l(_vm.items, function(item) {
                return _c(
                  "v-card-text",
                  { key: item.id },
                  [
                    _c(
                      "v-card",
                      {
                        class: {
                          "green accent-1": item.uploadedSize === item.fileSize
                        }
                      },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-row",
                              [
                                _c("v-col", { attrs: { cols: "9" } }, [
                                  _c(
                                    "strong",
                                    {
                                      staticStyle: { "word-wrap": "break-word" }
                                    },
                                    [_vm._v(_vm._s(item.itemName))]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        Number.parseFloat(
                                          item.fileSize / 1000
                                        ).toFixed(1)
                                      ) +
                                      " KB) " +
                                      _vm._s(item.status) +
                                      " "
                                  )
                                ]),
                                _c("v-spacer"),
                                _c(
                                  "v-col",
                                  { staticStyle: { "white-space": "nowrap" } },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.$store.getters[
                                                              "Ajax/loading"
                                                            ],
                                                          icon: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.downloadFile(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("cloud_download")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("global.downloadFile")
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _vm.readonly !== true
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.$store
                                                                  .getters[
                                                                  "Ajax/loading"
                                                                ],
                                                              icon: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeFile(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("close")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("global.removeFile")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            item.uploadedSize !== item.fileSize
                              ? _c("v-progress-linear", {
                                  attrs: {
                                    value:
                                      (item.uploadedSize / item.fileSize) * 100
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "v-card-text",
                [
                  _vm.readonly !== true
                    ? _c(
                        "v-row",
                        [
                          _c("v-col", { staticClass: "ma-3" }, [
                            _c(
                              "form",
                              { ref: "inputForm" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "primary",
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.fileInput.click()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("global.choseFile")))]
                                ),
                                _vm.uploadButton
                                  ? _c("input", {
                                      ref: "fileInput",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        type: "file",
                                        accept: _vm.accept
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.upload($event)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }